import ShopPayButton from './ShopPayButton';

export default ShopPayButton;
